export default "__VITE_ASSET__CcJ1tJUM__"